import { render, staticRenderFns } from "./SubmitButtons.vue?vue&type=template&id=a6dbb39a&scoped=true&lang=pug&"
import script from "./SubmitButtons.vue?vue&type=script&lang=js&"
export * from "./SubmitButtons.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButtons.vue?vue&type=style&index=0&id=a6dbb39a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dbb39a",
  null
  
)

export default component.exports